"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowResize = exports.wheel = exports.triggerPress = exports.triggerHover = exports.triggerFocus = exports.trackPress = exports.siblingOpen = exports.scrub = exports.pointer = exports.outsidePress = exports.none = exports.listNavigation = exports.linkPress = exports.keyboard = exports.itemPress = exports.inputPaste = exports.inputClear = exports.inputChange = exports.inputBlur = exports.incrementPress = exports.imperativeAction = exports.focusOut = exports.escapeKey = exports.drag = exports.disabled = exports.decrementPress = exports.closePress = exports.clearPress = exports.chipRemovePress = exports.cancelOpen = void 0;
const none = exports.none = 'none';
const triggerPress = exports.triggerPress = 'trigger-press';
const triggerHover = exports.triggerHover = 'trigger-hover';
const triggerFocus = exports.triggerFocus = 'trigger-focus';
const outsidePress = exports.outsidePress = 'outside-press';
const itemPress = exports.itemPress = 'item-press';
const closePress = exports.closePress = 'close-press';
const linkPress = exports.linkPress = 'link-press';
const clearPress = exports.clearPress = 'clear-press';
const chipRemovePress = exports.chipRemovePress = 'chip-remove-press';
const trackPress = exports.trackPress = 'track-press';
const incrementPress = exports.incrementPress = 'increment-press';
const decrementPress = exports.decrementPress = 'decrement-press';
const inputChange = exports.inputChange = 'input-change';
const inputClear = exports.inputClear = 'input-clear';
const inputBlur = exports.inputBlur = 'input-blur';
const inputPaste = exports.inputPaste = 'input-paste';
const focusOut = exports.focusOut = 'focus-out';
const escapeKey = exports.escapeKey = 'escape-key';
const listNavigation = exports.listNavigation = 'list-navigation';
const keyboard = exports.keyboard = 'keyboard';
const pointer = exports.pointer = 'pointer';
const drag = exports.drag = 'drag';
const wheel = exports.wheel = 'wheel';
const scrub = exports.scrub = 'scrub';
const cancelOpen = exports.cancelOpen = 'cancel-open';
const siblingOpen = exports.siblingOpen = 'sibling-open';
const disabled = exports.disabled = 'disabled';
const imperativeAction = exports.imperativeAction = 'imperative-action';
const windowResize = exports.windowResize = 'window-resize';